import { db } from "../../firebase";
import { collection, doc, getDoc } from "firebase/firestore";

const GetAgentBy_uid = async (agent_uid, bid) => {
  /**
   * input: null
   * output: agent details object
   * description: fetches agent details
   */

  try {
    const agentsCollection = await collection(db, "clients", bid, "agents");
    const agentDocument = await doc(agentsCollection, agent_uid);
    const agentsSnapshot = await getDoc(agentDocument);
    const agentDetails = agentsSnapshot.data();

    const agenId = agentDetails?.id;
    return { agenId, ...agentDetails };
  } catch (error) {
    console.log(error);
  }
};

export default GetAgentBy_uid;
